import React from 'react';

const Testenomial = () => {
    return (
        <div data-aos="fade-up"  className="lg:px-16 p-4 ">
            <div className="rounded-lg  p-6">
                <div className="text-center mb-6">
                    <p className="text-lg text-gray-700 mt-2">
                    </p>
                </div>

                <h1  style={{ fontFamily: "Helvetica" }} className="text-3xl font-bold text-center mb-8 text-black">
                    What leaders are saying about{' '}
                    <a
                        href="https://coachkshitij.com/"
                        className="text-blue-500 hover:underline"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Coach Kshitij
                    </a>
                </h1>

                <div data-aos="fade-up" className="lg:flex justify-center lg:gap-12">
                    {/* Testimonial Card */}
                    {[
                        {
                            name: 'Aneesh Garg',
                            title: 'Global CFO',
                            company: 'Accion Labs',
                            testimonial:
                                '"I feel proud of being associated with Kshitij. He was able to get the best out of me. If a senior business leader is looking to build a powerful Executive Presence, I will strongly recommend Kshitij!"',
                        },
                        {
                            name: 'Amitabh Nag',
                            title: 'Principal Data Scientist',
                            company: 'Microsoft, Redmond Washington',
                            testimonial:
                                '"Kshitij is a fantastic executive coach and he helped me with my recent promotion. Thank you so much Kshitij! Kshitij has a holistic approach to coaching for senior leaders."',
                        },
                        {
                            name: 'Avinash Kumar',
                            title: 'Digital, AI & Cloud Engineering Leader',
                            testimonial:
                                '"I wholeheartedly recommend Kshitij Sharma for his exceptional mentorship work in Executive Presence and Leadership."',
                        },
                    ].map(({ name, title, company, testimonial }, index) => (
                        <div
                            key={index}
                            className="bg-white text-black p-6 rounded-lg shadow-md mb-4 lg:mb-0 transition transform hover:scale-105"
                        >
                            <h2  style={{ fontFamily: "Helvetica" }} className="font-bold text-lg">{name}</h2>
                            <p className="text-sm text-gray-600">
                                {title}
                                {company && <span>, {company}</span>}
                            </p>
                            <div className="flex mt-2 text-yellow-500 justify-center">
                                {Array.from({ length: 5 }, (_, i) => (
                                    <i key={i} className="fa-solid fa-star" />
                                ))}
                            </div>
                            <p className="italic mt-4 text-gray-700">{testimonial}</p>
                        </div>
                    ))}
                </div>

                {/* <div className="bg-gray-100 text-black p-4 mt-8 rounded-lg shadow-md">
                    
                </div> */}
            </div>
            <div  data-aos="fade-up" className="bg-blue-600 rounded-lg flex flex-col md:flex-row items-center justify-center p-4">
                <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-0 justify-center mb-4">
                    {/* <img
                        src="https://images.pexels.com/photos/3776815/pexels-photo-3776815.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=100&w=100"
                        alt="Indian teacher giving a lecture"
                        className="rounded-full w-20 h-20 md:w-24 md:h-24 object-cover"
                    />
                    <img
                        src="https://images.pexels.com/photos/5428261/pexels-photo-5428261.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=100&w=100"
                        alt="Indian students in a classroom"
                        className="rounded-full w-20 h-20 md:w-24 md:h-24 object-cover"
                    />
                    <img
                        src="https://images.pexels.com/photos/4050426/pexels-photo-4050426.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=100&w=100"
                        alt="Person writing in a notebook"
                        className="rounded-full w-20 h-20 md:w-24 md:h-24 object-cover"
                    /> */}
                </div>

                <div className="md:ml-4  text-center md:text-left">
                    <p className="text-white text-sm mx-auto  p-2 text-cetner">
                        For more testimonials on how{' '}
                        <a
                            href="https://coachkshitij.com/"
                            className="text-white font-extrabold text-center hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Coach Kshitij
                        </a>{' '}
                        has helped leaders elevate their executive presence, feel free to explore them on{' '}
                        <a
                            href="https://www.linkedin.com/in/coachkshitij/"
                            className="text-white font-extrabold hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            LinkedIn
                        </a>.
                    </p>
                </div>
            </div>

        </div>
    );
};

export default Testenomial;
